import axios from 'axios';
import axiosRetry from 'axios-retry';
import { getApiAccessToken } from '~auth';

class SpellCheckClient {
  apiClient = null;
  language = '';

  constructor(apiClient, language) {
    this.apiClient = apiClient;
    this.language = language;
  }

  static async createSpellCheckerApiClient(apiUrl) {
    const token = await getApiAccessToken();
    const auth = `Bearer ${token}`;

    let client = axios.create({
      baseURL: apiUrl,
      timeout: 30000,
      headers: {
        Authorization: auth,
      },
    });

    const retries = 1;
    axiosRetry(client, {
      retries,
      retryDelay: axiosRetry.exponentialDelay,
      retryCondition: () => true,
      shouldResetTimeout: true,
    });

    return client;
  }

  async isAvailable() {
    try {
      await this.apiClient.get('/v2/languages');
      return true;
    } catch (error) {
      return false;
    }
  }

  async check(text) {
    const queryParams = new URLSearchParams();
    queryParams.set('text', text);
    queryParams.set('language', this.language);
    const response = await this.apiClient.get(
      `/v2/check?${queryParams.toString()}`
    );
    return response.data;
  }
}

export default SpellCheckClient;
